module.exports = __webpack_public_path__ + "img/university_2.e747a89d.jpg";